// extracted by mini-css-extract-plugin
export default {"voucherContainer":"wQyAr6_nYeCgI7j8dcCX","deleteVoucher":"s8aqLBVTK3Fvqv0q6n3L","titleContainer":"A5PPHEYnMW4vyWrXuPH3","title":"zTI6jFhJJDclXGSnnKj5"};